import { render, staticRenderFns } from "./EditSales.vue?vue&type=template&id=6b09b59c&"
import script from "./EditSales.vue?vue&type=script&lang=js&"
export * from "./EditSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports